import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  return (
    <footer className="footer no-print bg-light mt-5 pt-5">
      <Container>
        <Row className="g-4">
          
          {/* Información */}
          <Col md={6}>
            <Card className="h-100 shadow-sm border-0">
              <Card.Body>
                <h4 className="mb-3">JP Motors Guatemala</h4>

                <p className="text-muted">
                  Te asesoramos en tu compra y te ofrecemos las mejores facilidades
                  de pago para que puedas adquirir tu vehículo.
                </p>

                <p>
                  📍 <strong>Dirección:</strong><br />
                  Calzada Virgilio Rodríguez Macal Zona 0,  
                  A un costado de Taller Excel.
                </p>

                <p>📞 (502) 3973 - 1085</p>
                <p>✉️ info@jpmotorsgt.com</p>
              </Card.Body>
            </Card>
          </Col>

          {/* Mapa */}
          <Col md={6}>
            <Card className="h-100 shadow-sm border-0">
              <Card.Body>
                <h4 className="mb-3">¿Cómo llegar?</h4>

                <div style={{ borderRadius: "12px", overflow: "hidden" }}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3817.137882058831!2d-89.89072032484566!3d16.918489483890976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTbCsDU1JzA2LjYiTiA4OcKwNTMnMTcuMyJX!5e0!3m2!1ses!2sgt!4v1768006975251!5m2!1ses!2sgt"
                    width="100%"
                    height="250"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Mapa JP Motors"
                  />
                </div>

                <div className="d-grid mt-3">
                  <Button
                    variant="dark"
                    href="https://www.google.com/maps?q=16.918489,-89.890720"
                    target="_blank"
                  >
                    Abrir en Google Maps
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>

        <hr className="my-4" />

        <Row>
          <Col className="text-center text-muted">
            <small>
              &copy; 2025 JP Motors Guatemala. Todos los derechos reservados.
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
